/**
 * æä¸¾: æ§å«
 */
export enum Sex {
  /**
   * å¥³æ§
   */
  FEMALE = <any>'FEMALE',
  /**
   * ç·æ§
   */
  MALE = <any>'MALE'
}
